<template>
    <div>
        <AboutUs />

    </div>
</template>

<script>
import AboutUs from '@/components/AboutUs'
    export default {
        name: 'AboutView',
        components:{
            AboutUs
        }
    }
</script>

<style lang="scss" scoped>

</style>